import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Text } from '@amzn/dvui/dist/Text'
import { Modal } from '@amzn/dvui/dist/Modal'
import * as st from './playback.module.scss'
import { tryCatch } from '../../utils/tryCatch'
import { RecordRefTag } from '@utils'
import { getPlaybackClickstreamRef } from '../../utils/getPlaybackClickstreamRef'
import { getPlaybackProgress } from '../../utils/getPlaybackProgress'
import { PlayBox, SquarePlayButton } from '../playButton/PlayButton'
import {
  MaybeSpaContextProps,
  withMaybeSpaContext,
} from '../../../../shared/SPA/SpaContext'
import { PlayerContext } from '../../../../shared/player/integration/playbackArea'
import { triggerPlayback as triggerWindowsPlayback } from '@shared/SPA/triggers'
import {
  LicenseModal
} from '@shared/SPA/downloadButton/LicenseModal'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
export interface IPlaybackProps {
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  sessionId: string
  pageTitleId: string
  useNodeDeeplinking: boolean
  isRetail?: boolean
  isHover?: boolean
  isStartOver?: boolean
}

type PlaybackWithSpaContextProps = IPlaybackProps & MaybeSpaContextProps & AtfTreatmentProps

type Handler = undefined | ((e: React.MouseEvent) => void)

export const Playback = tryCatch(
  ({
    playbackData,
    sessionId,
    pageTitleId,
    isRetail,
    isStartOver,
    isHover = false,
    useNodeDeeplinking,
    hasDownloadCompleted,
    getDownload,
    strings,
    atfTreatment
  }: PlaybackWithSpaContextProps) => {
    if (!playbackData) {
      return null
    }

    const deeplinkingData = useNodeDeeplinking ? {} : {
      fallbackUrl: playbackData.fallbackURL,
      titleId: playbackData.playbackID,
      resumeTime: playbackData.resumeTime,
      signInUrl: playbackData.signInURL,
      sessionId,
      pageTitleId,
      ref: getPlaybackClickstreamRef(
        playbackData.contentType,
        playbackData.entitlementType
      ),
      videoType: playbackData.videoMaterialType,
    }

    const playbackTitleId = playbackData.playbackID
    const downloadCompleted =
      hasDownloadCompleted && hasDownloadCompleted(playbackTitleId)

    const downloadStatus = downloadCompleted && getDownload(playbackTitleId)
    const licenseModal = React.createRef<Modal>()
    const triggerOfflinePlayback = (e: React.MouseEvent) => {
      if (downloadStatus.showModalBeforePlay && !navigator.onLine) {
        licenseModal.current.open()
      } else {
        triggerWindowsPlayback(
          playbackTitleId,
          downloadStatus.download.DownloadId
        )
      }
      e.preventDefault()
    }

    const playbackContent = {
      contentConfig: {
        asin: playbackTitleId,
        trailer: false,
        position: playbackData.resumeTime,
        ref: getPlaybackClickstreamRef(
          playbackData.contentType,
          playbackData.entitlementType
        ),
        videoType: playbackData.videoMaterialType,
        useFullView: true,
      },
      signInUrl: playbackData.signInURL,
      playbackUrl: playbackData.playbackURL,
      fallbackUrl: playbackData.fallbackURL,
    }

    return (
      <PlayerContext.Consumer>
        {({ onPlay }) => {
          const triggerPlayback: Handler = (e) => {
            onPlay(playbackContent)
            e.preventDefault()
          }

          const handler = downloadCompleted
            ? triggerOfflinePlayback
            : useNodeDeeplinking
            ? triggerPlayback
            : undefined

          return (
            <>
              <RecordRefTag
                refTag='atv_dp_pb_main'
                className='avu-full-width-phablet dv-dp-node-playback'>
                <div className={st.playback}>
                  {(isRetail || isTreatment(atfTreatment, 'T1', 'T2', 'T3')) && !isHover ? (
                    <SquarePlayButton
                      deepLinkingData={deeplinkingData}
                      href={playbackData.playbackURL}
                      onClick={handler}
                      progress={getPlaybackProgress(playbackData.progress)}
                      forceDoubleHeight={true}
                      isStartOver={isStartOver}
                      {...(isTreatment(atfTreatment, 'T1', 'T3') && { shape: 'pill' })}
                      {...(isTreatment(atfTreatment, 'T1', 'T2', 'T3') && { className: 'avu-full-width-phablet' })}
                      atfTreatment={atfTreatment}>
                      <Text tag='span' string={playbackData.label} />
                    </SquarePlayButton>
                  ) : (
                    <PlayBox
                      deepLinkingData={deeplinkingData}
                      href={playbackData.playbackURL}
                      onClick={handler}
                      progress={getPlaybackProgress(playbackData.progress)}
                      isLarge={!isHover}
                      isStartOver={isStartOver}
                      isHover={isHover}>
                      <Text tag='span' string={playbackData.label} />
                    </PlayBox>
                  )}
                </div>
              </RecordRefTag>
              {downloadStatus && downloadStatus.showModalBeforePlay && (
                <LicenseModal
                  strings={strings}
                  downloadStatus={downloadStatus.download}
                  modalRef={licenseModal}
                />
              )}
            </>
          )
        }}
      </PlayerContext.Consumer>
    )
  }
)

export const ActionBoxPlayback = withMaybeSpaContext(Playback)
